<template>
  <div class="weixinband">
    <p>绑定微信</p>
		<wechatView ></wechatView>
  </div>
</template>

<script>
	import wechatView from '@/components/UserSettings/wechat/wechatView'
  export default {
    name: 'OpeonLog',
		components: {
			wechatView
		}
  }
</script>

<style>
.weixinband > p{
  font-size:24px;
  font-weight:500;
  color:rgba(38,38,38,1);
  line-height:24px;
  margin-bottom: 24px;
}
</style>